// BreadcrumbPagination.jsx
import React from 'react';
import {
  Box,
  Button,
  Pagination,
  Select,
  MenuItem,
  Typography,
  useMediaQuery
} from '@mui/material';
import { useModalContext } from '../contexts/ModalContext';
import PropTypes from 'prop-types';

const BreadcrumbPagination = ({
  page,
  rowsPerPage,
  totalPages,
  handleChangePage,
  handleChangeRowsPerPage,
  rowsPerPageOptions = [10, 25, 50, 100]
}) => {
  const isMobile = useMediaQuery('(max-width:600px)');

  const { theme } = useModalContext()

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2} mt={3}>

      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2" sx={{ color: theme ? '#fff' : '#000' }}>Rows per page:</Typography>
        <Select
          value={rowsPerPage}
          onChange={handleChangeRowsPerPage}
          size="small"
          sx={{ color: theme ? "#fff" : '#000' }}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option} sx={{ color:'#000' }}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box display="flex" alignItems="center" gap={2} flexWrap={isMobile ? 'wrap' : 'nowrap'}>
        <Button
          variant="outlined"
          disabled={page === 0}
          onClick={() => handleChangePage(null, page - 1)}
          sx={{ color: theme ? '#fff' : '#000', borderColor: theme ? '#fff' : '#000' }}
        >
          Previous
        </Button>

        <Pagination
          count={totalPages}
          page={page + 1}
          onChange={(e, newPage) => handleChangePage(e, newPage - 1)}
          color="primary"
          shape="rounded"
          siblingCount={isMobile ? 0 : 1}
          boundaryCount={1}
          sx={{
            '& .MuiPaginationItem-root': {
              color: theme ? '#fff' : '#000',
              borderColor: theme ? '#fff' : '#000',
              '&.Mui-selected': {
                backgroundColor: '#bcff38',
                color: '#000',
              },
            },
          }}
        />

        <Button
          variant="outlined"
          disabled={page + 1 >= totalPages}
          onClick={() => handleChangePage(null, page + 1)}
          sx={{ color: theme ? '#fff' : '#000', borderColor: theme ? '#fff' : '#000' }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
};

BreadcrumbPagination.propTypes = {
  page: PropTypes.number,
  rowsPerPage: PropTypes.number,
  totalPages: PropTypes.number,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.number)
};

export default BreadcrumbPagination;
